export const operators = [
  { name: "Олена R." },
  { name: "Ігор M." },
  { name: "Максим Ж." },
  { name: "Світлана K." },
  { name: "Андрій C." },
];
